import React, { FC } from "react";
import {
  Container,
} from './styles'
import { InfoBlock } from "../../../../../components";
import { useTranslation } from "react-i18next";

const Overview:FC<any> = ({data}) => {
  const [t] = useTranslation()
  const renderData = [
    {
      title:t("ENABLED"),
      id:'1',
      value: data?.enabled ? t("YES") : t("NO"),
    },
    {
      title:t("VISIBLE_TO_USER"),
      id:'2',
      value: data?.visible_to_user ? t("YES") : t("NO"),
    },
    {
      title:t("RECURRING_PAYMENTS_ENABLED"),
      id:'3',
      value: data?.recurring_payments_enabled ? t("YES") : t("NO"),
    },
    {
      title:t("FIXED_FEE"),
      id:'4',
      value: data?.fixed_fee,
    },
    {
      title:t("PERCENT_FEE"),
      id:'5',
      value: data?.percent_fee,
    },
  ]

  return(
    <Container>
      <InfoBlock
        data={renderData}
      />
    </Container>
  )
}

export default Overview
